<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
  // data(){
  //   return {
  //     head_icon:"./img/head.png",
  //   };
  // },
  // components:{
  //   Header,
  //   Intro,
  // }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
body {
  /* width: 100%;
  height: 100%; */
  /* margin-top: 0px;
  padding-top: 0px; */
  background-image: url(/img/webbg2.png);
  background-repeat: no-repeat;
  background-size: 35%;
  /* height: 150px; */
  background-color: #353535;
}
</style>
